import { format as formatDate } from 'date-fns';
import { memo } from 'react';
import { type ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import { ChevronLeft, ChevronRight } from '@air/next-icons';
import { IconButton } from '@air/primitive-icon-button';

export type DateInputHeaderProps = ReactDatePickerCustomHeaderProps;

export const DateInputHeader = memo(
  ({ date, prevMonthButtonDisabled, nextMonthButtonDisabled, increaseMonth, decreaseMonth }: DateInputHeaderProps) => {
    return (
      <div className="mb-3 flex items-center justify-between">
        <IconButton
          appearance="ghost"
          color="grey"
          disabled={prevMonthButtonDisabled}
          icon={ChevronLeft}
          label="Show previous month"
          onClick={decreaseMonth}
          size="small"
        />
        <div className="font-medium text-12 text-grey-11">{formatDate(date, 'MMMM yyyy')}</div>
        <IconButton
          appearance="ghost"
          color="grey"
          disabled={nextMonthButtonDisabled}
          icon={ChevronRight}
          label="Show next month"
          onClick={increaseMonth}
          size="small"
        />
      </div>
    );
  },
);

DateInputHeader.displayName = 'DateInputHeader';
